import { Col, Row } from "reactstrap"
import LightGrayBgWrapper from "../../../components/common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper"
import { PiCaretCircleUpDownFill } from "react-icons/pi"
import BarChart from "../../../components/common/AdminCommonComponents/Graphs/BarChart/BarChart"
import { MdPeople } from "react-icons/md"
import { FaArrowUpLong } from "react-icons/fa6"
import { IoEyeOutline } from "react-icons/io5"
import { FiBox } from "react-icons/fi"
import LineImg from "../../../assets/images/AdminPortal/ReportsAndAnalytics/profit-line.svg"
import ChartFooterCard from "../../../components/AdminPortalComponents/ReportsAndAnalytics/SalesReports/ChartFooterCard/ChartFooterCard"
import SalesDataCard from "../../../components/AdminPortalComponents/ReportsAndAnalytics/SalesReports/SalesDataCard/SalesDataCard"
import LineChart from "../../../components/common/AdminCommonComponents/Graphs/LineChart/LineChart"
import DonutChartComponent from "../../../components/AdminPortalComponents/Dashboard/SalesByDeviceChart"
import KPIChartStats from "../../../components/AdminPortalComponents/ReportsAndAnalytics/SalesReports/KPIChart/KPIChartStats"
import RoundedColoredDiv from "../../../components/AdminPortalComponents/ReportsAndAnalytics/SalesReports/RoundedColoredDiv/RoundedColoredDiv"
import DynamicButton from "../../../components/common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"
import AsusRogKeyboard from "../../../assets/images/AdminPortal/ReportsAndAnalytics/asus-rog-keyboard.png"
import ProductDescCard from "../../../components/AdminPortalComponents/ReportsAndAnalytics/SalesReports/ProductDescCard/ProductDescCard"
import ChangeYearDropdown from "../../../components/common/AdminCommonComponents/ChangeYearDropdown/ChangeYearDropdown"
import { buildStyles, CircularProgressbar } from "react-circular-progressbar"

const ReportsAndAnalytics = () => {
  const chartData = [
    {
      name: "Jan",
      uv: 4000,
      pv: 2400,
      amt: 2400,
    },
    {
      name: "Feb",
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: "Mar",
      uv: 2000,
      pv: 9800,
      amt: 2290,
    },
    {
      name: "Apr",
      uv: 2780,
      pv: 3908,
      amt: 2000,
    },
    {
      name: "May",
      uv: 1890,
      pv: 4800,
      amt: 2181,
    },
    {
      name: "Jun",
      uv: 2390,
      pv: 3800,
      amt: 2500,
    },
    {
      name: "Jul",
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
  ]

  const infoCardData = [
    { icon: <MdPeople size={18} />, info: { label: "Total Customers", value: "10,528" }, stats: { icon: <FaArrowUpLong />, value: "3%" } },
    { icon: <IoEyeOutline size={18} />, info: { label: "Total Views", value: "10,528" }, stats: { icon: <FaArrowUpLong />, value: "3%" } },
    { icon: <FiBox size={18} />, info: { label: "Best Sellers", value: "Asus ROG Strix" }, stats: { icon: <FaArrowUpLong />, value: "3%" } },
  ]

  const currentSalesData = [
    { title: "Current sales", value: "3%", revenue: "$192,065", lastYearRevenue: "$132,000 last year", lineImg: LineImg },
    { title: "Goal", value: "6%", revenue: "$192,065", lastYearRevenue: "$132,000 last year", lineImg: LineImg },
  ]

  const kpiChartData = [
    { label: "Tablet", value: 10 },
    { label: "Desktop", value: 15, strokeWidth: 15 },
    { label: "Mobile", value: 10 },
  ]
  const kpiChartColors = ["#FF8901", "#FBBD34", "#2F80ED", "#FF392B"]
  const kpiChartStats = [
    { divColor: "#2D4445", device: "Tablet", sales: "$550.81", percentage: "15.3%" },
    { divColor: "#FBBD34", device: "Desktop", sales: "$830.03", percentage: "64.2%" },
    { divColor: "#0095FF", device: "Mobile", sales: "$755.75", percentage: "48.6%" },
  ]

  const topOrdersData = [
    {
      src: AsusRogKeyboard,
      title: "Asus ROG Strix Scope NX TKL Moonlight White - Red Switch",
      serialNumber: "#A1008",
      items: "15 items",
      totalSales: "1024 Sales",
    },
    { src: AsusRogKeyboard, title: "IQUNIX ZX75 Dark Side Wireless Mechanical Keyboard", serialNumber: "#A1008", items: "15 items", totalSales: "1024 Sales" },
    { src: AsusRogKeyboard, title: "K580 SLIM MULTI-DEVICE WIRELESS KEYBOARD", serialNumber: "#A1008", items: "15 items", totalSales: "1024 Sales" },
    { src: AsusRogKeyboard, title: "QUNIX OG80 Camping Wireless Mechanical Keyboard", serialNumber: "#A1008", items: "15 items", totalSales: "1024 Sales" },
  ]

  return (
    <LightGrayBgWrapper>
      <div className="bg-white p-3 shadow">
        <Row>
          <Col xs="12" lg="8">
            <div className="p-3 rounded shadow">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <div className="fw-semibold">Sales in year</div>
                  <div>1024 Sales</div>
                </div>
                <div>
                  <ChangeYearDropdown options={[{ label: "2024" }, { label: "2025" }]} toggleIcon={<PiCaretCircleUpDownFill fill="#FF7A00" />} />
                </div>
              </div>

              <BarChart data={chartData} fillColor="#FF7A00" />

              <div className="mt-2">
                <ChartFooterCard data={infoCardData} theme="orange" />
              </div>
            </div>
          </Col>
          <Col>
            <SalesDataCard salesData={currentSalesData} />
          </Col>
        </Row>

        <Row className="mt-3">
          <Col xs="12" lg="4">
            <div className="shadow p-3 rounded">
              <div className="text-center">Retail and wholesale</div>
              <LineChart data={chartData} showDoubleLine />
            </div>

            <div className="shadow p-3 rounded mt-3">
              <div className="text-center fw-semibold">
                <div>KPI</div>
                <div>Total Product Sales Chart</div>
              </div>

              <div className="d-flex align-items-center justify-content-center">
                <DonutChartComponent data={kpiChartData} colors={kpiChartColors} />
              </div>

              <div className="mt-2">
                <KPIChartStats data={kpiChartStats} />
              </div>
            </div>

            <div className="shadow p-3 rounded mt-3 text-center">
              <div className="d-flex align-items-center justify-content-between">
                <div className="fw-medium">Highest return rate</div>
                <div className="d-flex align-items-center gap-2">
                  <RoundedColoredDiv backgroundColor="#EC7426" />
                  Product
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-center">
                <div className="h-25 w-25">
                  <CircularProgressbar
                    value={70}
                    text={`${70}%`}
                    styles={buildStyles({
                      textColor: "#000000",
                      pathColor: "#ea7231",
                      trailColor: "#eeeeee",
                    })}
                  />
                </div>
              </div>
              <div>The highest return rate and the product and the reasons for its return</div>
              <DynamicButton theme="orange" className="mt-3">
                View
              </DynamicButton>
            </div>
          </Col>
          <Col>
            {/* bar chart section */}
            <div className="p-3 rounded shadow">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <div className="fw-semibold">Sales by region</div>
                  <div>1024 Sales</div>
                </div>
                <div>
                  <ChangeYearDropdown options={[{ label: "2024" }, { label: "2025" }]} toggleIcon={<PiCaretCircleUpDownFill fill="#41B8E4" size={18} />} />
                </div>
              </div>

              <BarChart data={chartData} fillColor="#41B8E4" />

              <div className="mt-2">
                <ChartFooterCard data={infoCardData} theme="blue" />
              </div>
            </div>

            {/* line chart section */}
            <div className="mt-3 rounded shadow p-3">
              <div className="fw-semibold mb-2">Customers acquired over time</div>
              <LineChart data={chartData} strokeColor="#EC7426" showYAxis={false} />
            </div>

            <Row className="mt-3">
              <Col xs="12" xl="6">
                <div className="p-3 rounded shadow">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="fw-semibold">Top people</div>
                    <div>
                      <ChangeYearDropdown options={[{ label: "2024" }, { label: "2025" }]} toggleIcon={<PiCaretCircleUpDownFill fill="#FBBD34" size={18} />} />
                    </div>
                  </div>

                  <BarChart data={chartData} fillColor="#FBBD34" />
                </div>
              </Col>
              <Col xs="12" xl="6">
                <div className="p-3 rounded shadow">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <div className="fw-semibold">Top Orders</div>
                      <div>Total:80 Orders</div>
                    </div>
                    <div className="rounded border px-2 py-1 d-flex align-items-center gap-1">
                      <span>Top Orders</span>
                      <PiCaretCircleUpDownFill fill="#41B8E4" size={18} />
                    </div>
                  </div>

                  {topOrdersData.map((item, index) => (
                    <ProductDescCard data={item} key={index} />
                  ))}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </LightGrayBgWrapper>
  )
}

export default ReportsAndAnalytics
